import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  createStyles,
  Grid,
  makeStyles,
  Theme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useCleverlynkFunctions from "../../hooks/useCleverlynkFunctions";
import {
  selectActiveGroupMembers,
  selectCleverlynkGroup,
  selectCompany,
  selectIsMobile,
  selectItemsInCart,
  selectOpenGeo,
  selectTriggerNavToUserForm,
} from "../../redux/slices/cleverlynkSlice";

import { useTranslation } from "react-i18next";
import "../../i18n/config";

interface IMenuSelector {}

const MenuSelector = () => {
  const [imageWidth, setImageWidth] = useState<number>(200);

  const openGeo = useSelector(selectOpenGeo);
  const company = useSelector(selectCompany);
  const cleverlynkGroup = useSelector(selectCleverlynkGroup);
  const itemsInCart = useSelector(selectItemsInCart);
  const triggerNavToUserFormRef = useSelector(selectTriggerNavToUserForm);
  const activeGroupMembers = useSelector(selectActiveGroupMembers);
  const isMobile = useSelector(selectIsMobile);

  const { t } = useTranslation("groups");

  const { handleModifyOpenGeo, handleModifyCurrentClynkWithinGroup, handleSwapItemsBetweenCleverlynks } =
    useCleverlynkFunctions();

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        backgroundColor: "white",
        padding: 3,
        margin: "0 auto",
        borderRadius: 9,
        width: "90vw",
        maxWidth: cleverlynkGroup?.image !== undefined && !isMobile ? 550 : 400,
        zIndex: 4899,
        boxShadow: "3pt 3pt 11px 4px #00000026",
      },
      upperDiv: {
        minHeight: 80,
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "9px 9px 0px 0px",
        color: theme.palette.primary.contrastText,
      },
      lowerDiv: {
        minHeight: 80,
      },
      text1: {
        padding: 20,
        fontSize: "1.3rem",
      },
      text2: {
        paddingTop: 5,
        paddingBottom: 20,
        fontSize: "0.9rem",
      },
      text2alt: {
        paddingTop: 5,
        fontSize: "1.1rem",
      },
      text3: {
        padding: 20,
        fontSize: "0.9rem",
      },
      backdrop: {
        position: "fixed",
        height: "100%",
        top: 0,
        width: "100%",
        backgroundColor: "#0000005e",
        zIndex: 4898,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      select: {
        width: "80%",
        margin: 8,
      },
    })
  );

  const classes = useStyles();

  useEffect(() => {
    const elem = document.getElementsByTagName("body");
    if (elem && elem[0]) {
      if (openGeo) {
        elem[0].style.overflowY = "hidden";
      } else {
        elem[0].style.overflowY = "auto";
      }
    }
  }, [openGeo]);

  const handleClynkIdOnConfirm = (selectedId: string) => {
    if (selectedId.length > 0) {
      if (itemsInCart.length > 0) {
        handleSwapItemsBetweenCleverlynks(selectedId, triggerNavToUserFormRef);
      } else {
        handleModifyOpenGeo(false);
        handleModifyCurrentClynkWithinGroup({ id: selectedId });
      }
    }
  };

  return openGeo ? (
    <div
      onClick={() => handleModifyOpenGeo(false)}
      className={classes.backdrop}
      ref={(elem: any) => (elem && imageWidth === 200 ? setImageWidth(elem.scrollWidth - 32) : {})}>
      <div id="grouppopup-root" className={`${classes.root}`}>
        <Grid container direction="column" onClick={e => e.stopPropagation()}>
          <Grid item container direction="column" className={classes.upperDiv}>
            <Grid item>
              <Typography className={classes.text1} align="center">
                {t("welcomeTo")} {company?.name}
              </Typography>
            </Grid>
            {cleverlynkGroup?.image !== undefined && (
              <Grid item>
                <img
                  id="group-banner-img"
                  style={{
                    width: cleverlynkGroup?.image !== undefined && !isMobile ? 550 : 400,
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "contain",
                    marginBottom: -5,
                  }}
                  src={cleverlynkGroup?.image}
                  alt="Banner"
                />
              </Grid>
            )}
            {!cleverlynkGroup?.image && (
              <Grid item>
                <Typography className={classes.text2} align="center">
                  {cleverlynkGroup?.title}
                </Typography>
              </Grid>
            )}
          </Grid>
          <Grid item container direction="column" className={classes.lowerDiv}>
            {cleverlynkGroup?.image !== undefined && (
              <Grid item>
                <Typography variant="h6" className={classes.text2alt} align="center">
                  {cleverlynkGroup?.title}
                </Typography>
              </Grid>
            )}
            <Grid item container justifyContent="center">
              <FormControl required variant="outlined" className={classes.select}>
                <InputLabel id="select-selectedId-label">{"Elige"}</InputLabel>
                <Select
                  labelId="select-selectedId-label"
                  onChange={event => handleClynkIdOnConfirm(event.target.value as string)}
                  label="Zona">
                  {activeGroupMembers.map((clynkInfo, index) => (
                    <MenuItem key={`selectedId-${index}`} value={clynkInfo.id} disabled={!clynkInfo.open}>
                      {clynkInfo.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  ) : null;
};
export default MenuSelector;
